import { render, staticRenderFns } from "./SetUpAndProjectionsCard.vue?vue&type=template&id=5dca90b5&scoped=true"
import script from "./SetUpAndProjectionsCard.vue?vue&type=script&lang=js"
export * from "./SetUpAndProjectionsCard.vue?vue&type=script&lang=js"
import style0 from "./SetUpAndProjectionsCard.vue?vue&type=style&index=0&id=5dca90b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca90b5",
  null
  
)

export default component.exports